<template lang="pug">
  include /mixins
  div
    +b.ds-panel.--space_xl.--space_2xl-xl
      +e.element.--offset_bottom
        +b.ds-caption--size_md.--size_3md-xl.--appearance_center-till-md.--semibold.P {{ _("Загрузите, вертикальное или горизонтальное фото или видео результат до и после процедуры") }}
    +b.g-row.--appearance_spaced.--space_lg
      +b.g-cell.g-cols--narrow(v-for="item in choices.result_layout_type")
        +b.d-control-input.--appearance_flexible
          +e.element.INPUT(
            type="radio"
            :value="item.value"
            :id="item.value"
            name="result_layout_type"
            v-model="form.result_layout_type"
            @change="clearImages"
          )
          +e.LABEL.label--for-checkbox(
            :for="item.value"
          ) {{ item.label }}
    +b.ds-panel.--space_lg.--space_2xl-xl
      +e.element.--offset_top
        +b.g-row.--space_lg.--justify_center.--appearance_spaced
          +b.g-cell.g-cols.--6-md(
            v-for="item in keys"
            :class="isVertical ? 'g-cols--8 g-cols--auto-sm' : 'g-cols--10 g-cols--8-sm'"
          )
            result-loader(
              :key="form.result_layout_type+'_'+item.name"
              :width="loaderConfig.width"
              :height="loaderConfig.height"
              :ratio="loaderConfig.ratio"
              :rate="2"
              :post-resource="isEquipment ? $options.EquipmentResultImageCreate : $options.ResultImageCreate",
              :orientation="form.result_layout_type"
              :uploaded-file="form.localFiles[item.name]"
              v-bind="item"
              @update="$emit('upload', { val: $event, name: item.name })"
              @image="setImage($event, item.name)"
            )
</template>

<script>
import {
  ResultImageCreate,
  EquipmentResultImageCreate,
} from '@api/store.service'

export default {
  ResultImageCreate,
  EquipmentResultImageCreate,

  props: ['form', 'choices', 'orientationMap', 'isEquipment'],

  data() {
    return {
      keys: [
        {
          name: 'before',
          titles: {
            create: this._('Загрузить ДО'),
            update: this._('Изменить ДО'),
            initial: this._('Фото ДО'),
          },
          additional: { type: 'before' },
        },
        {
          name: 'after',
          titles: {
            create: this._('Загрузить После'),
            update: this._('Изменить После'),
            initial: this._('Фото После'),
          },
          additional: { type: 'after' },
        },
      ],
    }
  },

  computed: {
    isVertical() {
      return this.form.result_layout_type === this.orientationMap.VERTICAL
    },

    loaderConfig() {
      return {
        ratio: this.isVertical ? 12 / 14 : 14 / 9,
        width: this.isVertical ? 188 : 310,
        height: this.isVertical ? 240 : 170,
      }
    },
  },

  methods: {
    clearImages() {
      this.$emit('clear')
    },

    setImage(val, key) {
      this.$set(this.form.localFiles, key, val)
    },
  },
}
</script>
